import React from 'react';
import Imgage from '../../assets/images/img.png';
import HomeColumnBetter from "../../components/HomeColumnBetter";
import './style.css';
import ADS from './Washta Icons-01.svg';
import CardImg from '../../assets/images/Paymnet.png';
import Squareimg from '../../assets/images/Square.svg';
import ASDf from './Washta-Icons.svg';

// Data ko ek array mein organize karna best practice hai
const cardData = [
  {
    image: ADS,
    text: "Select Your Location and Request Your Carwash",
    text1: "Our trusted car wash providers are already stationed at popular malls and parking lots, no waiting for them to arrive! Simply open the app, see the available carwash service, and request a cleaning. It’s that easy.",
    key: "card-location",
  },
  {
    image: ASDf,
    text: "Enjoy a Spotless Car When You Return",
    text1: "By the time you’re done, your car will be spotless, shining, and ready to go. No waiting in lines, no extra trips, and no hassle. Just enjoy your cleaned car, right where you left it.",
    key: "card-spotless",
  },
  {
    image: CardImg,
    text: "Pay Online, Hassle-Free",
    text1: "No need to carry cash. With our secure in-app payment system, you can use your credit/debit and pay in seconds. Fast, secure, and convenient.",
    key: "card-payment",
  },
  {
    image: Squareimg,
    text: "Run Your Errands, We’ll Take Care of the Rest",
    text1: "While you’re busy shopping, enjoying a meal, or attending meetings, our professional car wash teams will get to work. There’s no need to coordinate schedules or meet anyone; we’ll handle everything while you go about your day.",
    key: "card-errands",
  },
];

const Card = () => {
  return (
    <div className='btn-card p-4'> {/* Added some padding for better spacing on small screens */}
      {/* Main Container */}
      {/* 
        Mobile First: flex-col (sab kuch ek column mein)
        Large Screens (lg) & up: flex-row (side-by-side layout)
      */}
      <div className="flex flex-col lg:flex-row gap-8 self-stretch w-full max-w-7xl m-auto">
        
        {/* === Left Side: Image Container === */}
        {/* 
          - lg:w-2/5: Badi screens par yeh container 40% width lega.
          - h-[400px] md:h-[500px] lg:h-auto: Height ko alag-alag screens ke liye adjust kiya hai.
          - lg:sticky lg:top-8: Badi screens par image scroll ke saath stick rahegi.
        */}
        <div className="relative w-full lg:w-2/5 h-[400px] md:h-[500px] lg:h-auto lg:self-stretch rounded-[26px] overflow-hidden">
          <img 
            src={Imgage} 
            alt="main" 
            className="w-full h-full object-cover" // object-cover ensures the image fills the container without stretching
          />
        </div>

        {/* === Right Side: Cards Grid === */}
        {/* 
          - lg:w-3/5: Badi screens par yeh container bachi hui 60% width lega.
          - grid: CSS Grid layout enable karega.
          - grid-cols-1: Mobile par 1 column.
          - md:grid-cols-2: Tablet par 2 columns.
        */}
        <div className="w-full lg:w-3/5 grid grid-cols-1 md:grid-cols-1 gap-8">
          {cardData.map((card) => (
            <HomeColumnBetter
              key={card.key}
              image={card.image}
              text={card.text}
              text1={card.text1}
              className="flex flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-6 h-full" // h-full ensures all cards have same height in a grid row
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card;